import "../css/Desire.css";

export default function Desire({ item, getColor, emptyImage, emptyLabel, activeLabel }) {
    const label = item ? activeLabel : emptyLabel;

    return (
        <div className="desire-windows">
            <div className="desire-label">{label}</div>
            <button
                className="desire-windows-button"
                style={{ color: getColor(item ? item.star : 3) }}
            >
                {item ? item.name : "尚未定轨"}
            </button>
            {item?.subtitle && <div className="desire-subtitle">{item.subtitle}</div>}
            {item?.tags?.length ? (
                <div className="desire-tags">
                    {item.tags.slice(0, 2).map((tag) => (
                        <span key={tag} className="desire-tag">{tag}</span>
                    ))}
                </div>
            ) : null}
            <img
                src={item ? item.image : emptyImage}
                alt={item ? item.name : "定轨占位图"}
                className="wish-picture"
            />
        </div>
    );
}
